export default "__VITE_ASSET__DWKX$Sv___"